export const HOME_CONSTANTS = {

    ANIMATION_TIMINGS: {
        FEATURE_INTERVAL: 3000,
        FEATURE_START_DELAY: 1000
    }

} as const;
